import { ValidationErrors, ValidatorFn, AbstractControl } from "@angular/forms";
export const EmailDomainValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  if (!control.value) {
    return null;
  }

  const email = control.value.toLowerCase();
  const parts = email.split("@");
  if (parts.length < 2 || !parts[1]) {
    return null;
  }

  const domainPart = parts[1];
  const domainParts = domainPart.split(".");
  if (domainParts.length < 2) {
    return null;
  }

  const domain = domainParts[0];

  const commonDomains: string[] = [
    "gmail",
    "yahoo",
    "outlook",
    "hotmail",
    "live",
    "aol",
    "icloud",
    "zoho",
    "protonmail",
    "mail",
    "yandex",
    "gmx",
    "tutanota",
    "rediffmail",
    "fastmail",
  ];

  if (commonDomains.includes(domain)) {
    return { invalid_domain: true };
  }

  return null;
};
